export let StudyLevel = /*#__PURE__*/function (StudyLevel) {
  StudyLevel["LowerPrimary"] = "lower_primary";
  StudyLevel["Primary"] = "primary";
  StudyLevel["LowerSecondary"] = "lower_secondary";
  StudyLevel["UpperSecondary"] = "upper_secondary";
  StudyLevel["PostSecondaryNonTertiary"] = "post_secondary_non_tertiary";
  StudyLevel["TertiaryShortCourse"] = "tertiary_short_course";
  StudyLevel["Bachelor"] = "bachelor";
  StudyLevel["Master"] = "master";
  StudyLevel["Doctorate"] = "doctorate";
  return StudyLevel;
}({});